var _circle, _path, _g, _path2, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPowerOff(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 9.54778,
    cy: 9.04778,
    r: 9.04778,
    fill: "#FAFAFB"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_34_16",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 3,
    y: 2,
    width: 13,
    height: 14
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.491 2.18292H3.59961V15.3956H15.491V2.18292Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_34_16)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.4914 9.46323C15.4914 7.14062 14.1022 5.0218 11.9939 4.06567V5.73784C13.2628 6.56834 14.0155 7.94879 14.0155 9.46183C14.0155 11.9212 12.0107 13.9228 9.54572 13.9228C7.08071 13.9228 5.07457 11.9226 5.07457 9.46183C5.07457 7.94879 5.82722 6.56834 7.0975 5.73645V4.06567C4.98923 5.0218 3.60004 7.14062 3.60004 9.46323C3.60004 12.735 6.2665 15.3954 9.54572 15.3954C12.8249 15.3954 15.4914 12.735 15.4914 9.46323Z",
    fill: "#005FC5"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_34_16",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 3,
    y: 2,
    width: 13,
    height: 14
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.491 2.18292H3.59961V15.3956H15.491V2.18292Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_34_16)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.78383 2.18274H9.30678C9.04657 2.18274 8.83392 2.3949 8.83392 2.65452V6.49297C8.83392 6.75259 9.04657 6.96475 9.30678 6.96475H9.78383C10.044 6.96475 10.2567 6.75259 10.2567 6.49297V2.65452C10.2567 2.3949 10.0454 2.18274 9.78383 2.18274Z",
    fill: "#005FC5"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPowerOff);
export default __webpack_public_path__ + "static/media/PowerOff.83bbbf3b7e845b8b1b49d247d00f163a.svg";
export { ForwardRef as ReactComponent };